export type CheckoutState = Record<string, unknown>;

const NON_GDPR_DATA: string[] = [
  'campaignId',
  'changeReason',
  'city',
  'cityId',
  'clientUuid',
  'coupon',
  'electricityChangeReason',
  'electricityProductCode',
  'electricityProvider',
  'electricityRelocationDate',
  'electricityTerminationDate',
  'electricityUsage',
  'gasChangeReason',
  'gasProductCode',
  'gasProvider',
  'gasRelocationDate',
  'gasTerminationDate',
  'gasUsage',
  'hasSmartMeter',
  'heatedArea',
  'heatingSystem',
  'houseType',
  'houseYearOfConstruction',
  'interestInHeatPump',
  'interestInPv',
  'interestInStromWallet',
  'interestInWallBox',
  'interestedInSmartMeter',
  'isInterestedInSmartMeter', // when querying the order the field name has an "is"-prefix... well...
  'isAlternativeAccountHolder',
  'isBundleIntention',
  'isContractTerminated',
  'isElectricityContractTerminated',
  'isGasContractTerminated',
  'isHouseOwner',
  'legalText',
  'livingSpace',
  'marketingLegalConsentText',
  'meter',
  'numberOfResidents',
  'payment',
  'people',
  'productCode',
  'provider',
  'relocationDate',
  'sourceOfHeat',
  'terminationDate',
  'usage',
  'usageHT',
  'usageNT',
  'usageUnknown',
  'uvpCode',
  'vpCode',
  'zip',
] as const;

//replace chars with a representation
const sanitizeString = (value?: string) =>
  value?.replaceAll(/[A-Z]/g, 'W').replaceAll(/[a-z]/g, 'w').replaceAll(/\d/g, 'd').replaceAll('@', '[at]');

export const sanitizeStateForMonitoring = (state?: CheckoutState): Record<string, unknown> => {
  return Object.fromEntries(
    Object.entries(state ?? {}).map(([key, value]) => {
      if (NON_GDPR_DATA.includes(key) || typeof value === 'boolean') {
        return [key, value];
      }

      if (typeof value === 'number') {
        //convert numbers to their length
        return [key, value.toString().length];
      }

      if (typeof value === 'string') {
        return [key, sanitizeString(value)];
      }

      return [key, undefined];
    }),
  );
};
